import { ISharingEnterTraffic, TSharingCurrentTraffic } from 'shared/atoms';
import { EPageType } from 'shared/constant';

export const TRACKING_PARAMS_FROM_URL = [
  'impr_id',
  'campaign_id',
  'ad_id',
  'group_id',
  'could_share_user_cnt',
  'group_position',
  'enter_type',
  // page_name/current_page端内透传，前端上报的是current_page_name
  'page_name',
  'current_page',
] as string[];

export const TRACKING_PARAM_MAPPING = [
  ['is_ad', 'is_ad_source'] as const,
  ['share_form', 'share_type'] as const,
  ['position', 'click_position'] as const,
] as string[][];
export const SharingEnterTrafficUtil = {
  getShareContentExtra: (traffic: ISharingEnterTraffic) => {
    return {
      share_content_type: traffic.pageType,
      share_content_id: traffic.pageId || null,
    };
  },
};

export const SharingCurrentTrafficUtil = {
  getPageClickId: (traffic: TSharingCurrentTraffic): string => {
    switch (traffic.pageType) {
      case EPageType.Gallery:
      case EPageType.FIZZ:
      case EPageType.VIDEO:
        return traffic.groupId;
      case EPageType.HASHTAG:
        return traffic.hashtagId;
      case EPageType.POI:
        return traffic.poiId;
      case EPageType.USER:
      default:
        return traffic.userId;
    }
  },

  getEnterPageExtra: (traffic: TSharingCurrentTraffic): Record<string, string> => {
    switch (traffic.pageType) {
      case EPageType.Gallery:
        return {
          enter_page_type: EPageType.Gallery,
          enter_page_id: traffic.groupId,
        };
      case EPageType.FIZZ:
        return {
          enter_page_type: EPageType.FIZZ,
          enter_page_id: traffic.groupId,
        };
      case EPageType.VIDEO:
        return {
          enter_page_type: EPageType.VIDEO,
          enter_page_id: traffic.groupId,
        };
      case EPageType.HASHTAG:
        return {
          enter_page_type: EPageType.HASHTAG,
          enter_page_id: traffic.hashtagId,
        };
      case EPageType.POI:
        return {
          enter_page_type: EPageType.POI,
          enter_page_id: traffic.poiId,
        };
      case EPageType.USER:
      default:
        return {
          enter_page_type: EPageType.USER,
          enter_page_id: traffic.userId,
        };
    }
  },
};
